module.exports = __webpack_public_path__ + "static/media/logo_towersix_primary.701707a9.svg";